import React from 'react'
import AppProvider from '@contexts/app'
import AuthProvider from '@contexts/auth'
import ConfigProvider from '@contexts/config'
import SliderProvider from '@contexts/slider'
import SidepanelProvider from '@contexts/sidepanel'

/**
 * The component gets all context providers in one place.
 */
export default function Context({ children }: React.PropsWithChildren<{}>) {
    return (
        <AuthProvider>
            <ConfigProvider>
                <AppProvider>
                    <SliderProvider>
                        <SidepanelProvider>
                            {children}
                        </SidepanelProvider>
                    </SliderProvider>
                </AppProvider>
            </ConfigProvider>
        </AuthProvider>
    )
}